import { User } from '@/modules/user/user';
import { validateSubscription } from '@shared/common/data-validators/subscription.validator';

export class Subscription {

    public static validate(data: any): string[] {
        return validateSubscription(data);
    }
    public id!: string;
    public label!: string;
    public createdAt!: Date;
    public createdById!: string;
    public createdBy!: User;
    public updatedById!: string;
    public updatedBy!: User;

    constructor(opt: any) {
        Object.assign(this, opt);
    }
}
